import { styled } from '@mui/material';
import { alpha } from '@mui/system';
import Box from '@mui/material/Box';
import { Rnd } from 'react-rnd';
//Local files
import DeleteButton from 'components/Documents/Builder/Element/Common/DeleteButton/DeleteButton';

const CustomHandle = ({ color, ...otherProps }) => (
  <Box
    sx={{
      background: '#fff',
      border: '1px solid',
      borderColor: 'border',
      height: 10,
      width: 10,
      padding: 0,
      margin: '5px 0 0 5px',
    }}
    {...otherProps}
  />
);

const Wrapper = styled(Box,
  { shouldForwardProp: (prop) => prop !== 'active' })( ({ theme, active }) => ({
  height: '100%',
  position: 'relative',
  userSelect: 'none',
  color: theme.palette.primary.main,
  backgroundColor: alpha('#fdff98', 0.5),
  border: '2px solid',
  borderColor: 'transparent',
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  padding: '4px 2px',
  '& > *': { flexShrink: 0  },
  '&:hover': {
    backgroundColor: '#fdff98',
  },
  ...(active && {
    borderColor: theme.palette.primary.main,
    backgroundColor:'#fdff98'
  })
}));

const ElementWrapper = ({ position, size, wrapperSx, maxHeight, maxWidth, active, Drawer, drawerProps, icon, text, onClick, onTransform, onDelete, ...otherProps }) => {
  return (
    <>
      <Drawer {...drawerProps} />
      <Rnd
        style={{ zIndex: 150 }}
        position={position}
        size={size}
        resizeHandleComponent={!active && { bottomRight: <CustomHandle {...otherProps} /> }}
        onDragStop={onTransform}
        onResizeStop={onTransform}
        maxHeight={maxHeight}
        maxWidth={maxWidth}
      >
        {active && <DeleteButton onClick={onDelete} />}
        <Wrapper active={active} onClick={onClick} sx={{wrapperSx}}>
          {icon && icon}
          {text && text}
        </Wrapper>
      </Rnd>
    </>
  )
}

export default ElementWrapper;
